import { action } from 'easy-peasy';
import { IActionResetUser } from '../types';

const resetUser: IActionResetUser = action(state => {
  state.current = null;
});

export default resetUser;
